import {
  COMPANY_NAME_MALFORMED,
  EXPORT_DATE_LATER_THAN_ARRIVAL_DATE,
  EXPORT_DATE_MISSING,
  FOREIGN_PORT_MISSING,
  FREIGHT_COST_LESS_THAN_LINES_COUNT,
  FREIGHT_COST_MISSING,
  HOUSE_AIR_BILL_NUMBER_MISSING,
  HOUSE_AIR_BILL_NUMBER_TOO_LONG,
  HOUSE_AIR_BILL_PREFIX_MISSING,
  HOUSE_AIR_BILL_PREFIX_WRONG_LENGTH,
  HOUSE_BILL_CARRIER_MALFORMED,
  HOUSE_BILL_CARRIER_MISSING,
  HOUSE_BILL_CARRIER_WRONG_LENGTH,
  HOUSE_BILL_NUMBER_MALFORMED,
  HOUSE_BILL_NUMBER_MISSING,
  HOUSE_BILL_TOO_LONG,
  IDENTIFIER_MALFORMED,
  IT_DATE_LATER_THAN_ENTRY_DATE,
  IT_DATE_MISSING,
  IT_NUMBER_MALFORMED,
  IT_NUMBER_MISSING,
  MASTER_AIR_BILL_NUMBER_TOO_LONG,
  MASTER_AIR_BILL_PREFIX_MISSING,
  MASTER_AIR_BILL_PREFIX_WRONG_LENGTH,
  MASTER_BILL_CARRIER_MALFORMED,
  MASTER_BILL_CARRIER_MISSING,
  MASTER_BILL_CARRIER_WRONG_LENGTH,
  MASTER_BILL_NUMBER_MALFORMED,
  MASTER_BILL_NUMBER_MISSING,
  MASTER_BILL_TOO_LONG,
  MISSING_ADDRESS,
  MISSING_CITY,
  MISSING_COMPANY_NAME,
  MISSING_COUNTRY,
  MISSING_IDENTIFIER,
  MISSING_IDENTIFIER_QUALIFIER,
  POSTAL_CODE_MALFORMED,
  QUALIFIER_MALFORMED,
  QUANTITY_MISSING,
  QUANTITY_UNIT_MISSING,
  WRONG_IDENTIFIER_FORMAT,
} from '@constants/entity-validation-messages';

export const blMissingFields = [
  IT_DATE_MISSING,
  IT_NUMBER_MISSING,
  FREIGHT_COST_MISSING,
  FREIGHT_COST_LESS_THAN_LINES_COUNT,
  IT_NUMBER_MALFORMED,
  IT_DATE_LATER_THAN_ENTRY_DATE,
  MASTER_BILL_NUMBER_MISSING,
  MASTER_BILL_CARRIER_MISSING,
  MASTER_AIR_BILL_PREFIX_MISSING,
  MASTER_BILL_CARRIER_WRONG_LENGTH,
  MASTER_AIR_BILL_PREFIX_WRONG_LENGTH,
  MASTER_BILL_TOO_LONG,
  MASTER_AIR_BILL_NUMBER_TOO_LONG,
  HOUSE_BILL_CARRIER_MISSING,
  HOUSE_AIR_BILL_PREFIX_MISSING,
  HOUSE_BILL_NUMBER_MISSING,
  HOUSE_AIR_BILL_NUMBER_MISSING,
  HOUSE_BILL_CARRIER_WRONG_LENGTH,
  HOUSE_AIR_BILL_PREFIX_WRONG_LENGTH,
  HOUSE_BILL_TOO_LONG,
  HOUSE_AIR_BILL_NUMBER_TOO_LONG,
  MASTER_BILL_CARRIER_MALFORMED,
  MASTER_BILL_NUMBER_MALFORMED,
  HOUSE_BILL_CARRIER_MALFORMED,
  HOUSE_BILL_NUMBER_MALFORMED,
  QUANTITY_MISSING,
  QUANTITY_UNIT_MISSING,
];
export const blSellerMissingFields = [
  MISSING_COMPANY_NAME,
  MISSING_COUNTRY,
  MISSING_CITY,
  MISSING_ADDRESS,
  COMPANY_NAME_MALFORMED,
  QUALIFIER_MALFORMED,
  IDENTIFIER_MALFORMED,
  POSTAL_CODE_MALFORMED,
];
export const blConsigneeMissingFields = [
  MISSING_COMPANY_NAME,
  MISSING_IDENTIFIER,
  MISSING_IDENTIFIER_QUALIFIER,
  WRONG_IDENTIFIER_FORMAT,
  COMPANY_NAME_MALFORMED,
  QUALIFIER_MALFORMED,
  IDENTIFIER_MALFORMED,
  POSTAL_CODE_MALFORMED,
];
export const blBuyerMissingFields = [
  MISSING_COMPANY_NAME,
  MISSING_IDENTIFIER,
  MISSING_IDENTIFIER_QUALIFIER,
  WRONG_IDENTIFIER_FORMAT,
  COMPANY_NAME_MALFORMED,
  QUALIFIER_MALFORMED,
  IDENTIFIER_MALFORMED,
  POSTAL_CODE_MALFORMED,
];
export const blMissingFieldsSpec = [EXPORT_DATE_MISSING, EXPORT_DATE_LATER_THAN_ARRIVAL_DATE, FOREIGN_PORT_MISSING];
